export function partnerPostSlider() {
    $(".partner-post-slider").slick({
        prevArrow: '<div class="sl-btn sl-btn--prev"><svg viewBox="0 0 52 13" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m10.178 12.38-10-5.773 10-5.774v4.774h40a1 1 0 1 1 0 2h-40v4.773Z"/></svg></div>',
        nextArrow: '<div class="sl-btn sl-btn--next"><svg viewBox="0 0 52 13" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m41.292.833 10 5.774-10 5.773V7.607h-40a1 1 0 1 1 0-2h40V.833Z"/></svg></div>',
        fade: true,
        dots: true,
        appendArrows: ".partner-post-slider-control",
        appendDots: ".partner-post-slider-control",
        fade: true,
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/partner-post-slider.js